import { fadeIn, fadeOut, isVisible, slideDown, slideUp } from './helper-functions.js';

export default function setupTeTapapa() {

    const accordionData = {
        "top": {
            "title": "Ka puta ki te whaiao,  <br>ki te ao mārama",
            "desc": "Legislated Workforce and Professional Body",
            "accordion": [{
                "title": "Te Ture",
                "title_bold": "Legislation",
                "text": "<ul>\n<li>Legislation to formalise the new workforce requirements<\/li>\n<li>Scope of practice<\/li>\n<li>Protection of Financial Mentor title<\/li>\n<li>Regulations, compliance code and policy <img class=\"alignnone size-full wp-image-16879\" src=\"\/_resources\/themes\/fincap/\dist/\images\/Asset-2.png\" alt=\"\" width=\"17\" height=\"16\" \/><\/li>\n<\/ul>\n"
            }, {
                "title": "Te Waitohi",
                "title_bold": "Service Accreditation Body",
                "text": "<ul>\n<li>Accreditation body infrastructure<\/li>\n<li>Code of conduct<\/li>\n<li>Service standards<\/li>\n<li>Compliance<\/li>\n<li>Quality assurance framework<\/li>\n<li>Complaints process<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Tomokanga",
                "title_bold": "Registration Body",
                "text": "<ul>\n<li>Peak body infrastructure with independence from Government<\/li>\n<li>Competencies and Standards framework<\/li>\n<li>Quality assurance process<\/li>\n<li>Complaints handling mechanisms<\/li>\n<li>Advocacy and policy advice<\/li>\n<li>Continuing professional development<\/li>\n<li>Data collection and analytics<\/li>\n<li>Strategic remuneration<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Pūtea Matomato",
                "title_bold": "Funding",
                "text": "<ul>\n<li>Investment strategy<\/li>\n<li>Multiple funding streams<\/li>\n<li>Sustainable and fit for purpose funding models<\/li>\n<li>Equitable regional funding<\/li>\n<\/ul>\n"
            }],
            "popup_bg": "#fad3df",
            "accordion_bg": "#f8a7c4"
        }, "top-right": {
            "title": "Mahi Tika, Mahi Āwhina, Mahi Rangatira",
            "desc": "Competencies and Standards",
            "accordion": [{
                "title": "Tikanga Matua ",
                "title_bold": "Core Competencies",
                "text": "<ul>\n<li>Technical, analytical and problem solving skills<\/li>\n<li>Interpersonal and communication skills<\/li>\n<li>Crisis management and Mental Health 101<\/li>\n<li>Income and benefit support<\/li>\n<li>Cultural competency<\/li>\n<li>Document management<\/li>\n<li>Referral processes<\/li>\n<\/ul>\n"
            }, {
                "title": "Tikanga Whakakaha",
                "title_bold": "Specialist Competencies",
                "text": "<ul>\n<li>Insolvency and complex debt issues<\/li>\n<li>Legislative compliance<\/li>\n<li>Housing support<\/li>\n<li>Migrant and refugee support<\/li>\n<li>Community finance<\/li>\n<li>Advocacy<\/li>\n<li>Economic harm<\/li>\n<li>Kiwisaver<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Kawa Matua",
                "title_bold": "Practice Standards",
                "text": "<ul>\n<li>Code of conduct<\/li>\n<li>Code of ethics<\/li>\n<li>Practice guidelines<\/li>\n<li>Record keeping and data management<\/li>\n<li>Risk management<\/li>\n<li>Confidentiality<\/li>\n<li>Te Tiriti o Waitangi<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Hua o te Mahi",
                "title_bold": "Assessment",
                "text": "<ul>\n<li>Quality assurance<\/li>\n<li>Registration<\/li>\n<li>Professional development<\/li>\n<li>Self-assessment<\/li>\n<li>Peer review<\/li>\n<li>Client feedback<\/li>\n<li>Remuneration progression<\/li>\n<\/ul>\n"
            }],
            "popup_bg": "#f9a7c4",
            "accordion_bg": "#fad3df"
        }, "bottom-right": {
            "title": "Te Tihi o Manono",
            "desc": "Training and Career <br>Pathways",
            "accordion": [{
                "title": "Kia ako tonu",
                "title_bold": "Training Courses",
                "text": "<ul>\n<li>FMIC microcredential (Level 4, 16 credits)<\/li>\n<li>Consumer Credit microcredential (Level 5, 17 credits)<\/li>\n<li>Massey Financial Capability Practitioners Course microcredential (Level 5, 10 credits)<\/li>\n<li>Careerforce NZ Diploma in Health and Wellbeing (Level 5, 120 credits)<\/li>\n<li>Mental Health 101 and First Aid<\/li>\n<li>Modular learning (Compulsory, Elective, Specialist)<\/li>\n<li>Registered training providers (University, Polytechnic, Whare Wānanga)<\/li>\n<li>Independent training providers (unregistered)<\/li>\n<li>NZQA framework approved courses<\/li>\n<\/ul>\n"
            }, {
                "title": "Ka pai ki mua, ka pai ki muri",
                "title_bold": "Recognition of Prior Learning",
                "text": "<ul>\n<li>Assessment of prior learning and experience<\/li>\n<li>Recognition of prior learning and experience<\/li>\n<li>Cultural knowledge and capability<\/li>\n<li>Development of guidelines<\/li>\n<\/ul>\n"
            }, {
                "title": "Tuakana-teina",
                "title_bold": "Professional Supervision",
                "text": "<ul>\n<li>Provisional period supervision<\/li>\n<li>Internal and external supervision<\/li>\n<li>Registration requirements<\/li>\n<li>Training for supervisors<\/li>\n<li>Development of criteria<\/li>\n<li>Evaluation<\/li>\n<li>Cultural supervision<\/li>\n<\/ul>\n"
            }, {
                "title": "He tohu whakamana",
                "title_bold": "Qualifications",
                "text": "<ul>\n<li>Microcredentials<\/li>\n<li>Certificate in Financial Mentoring<\/li>\n<li>Diploma in Financial Mentoring<\/li>\n<li>Certificate in Service Management<\/li>\n<li>Minimum entry level standards<\/li>\n<\/ul>\n"
            }],
            "popup_bg": "#f1799f",
            "accordion_bg": "#f9a7c4"
        }, "bottom": {
            "title": "Te Pā Harakeke",
            "desc": "Communities of Practice",
            "accordion": [{
                "title": "He Whare Wānanga ",
                "title_bold": "Peer-to-Peer Learning",
                "text": "<ul>\n<li>Coaching support<\/li>\n<li>Problem solving<\/li>\n<li>Case study discussion<\/li>\n<li>Sharing knowledge, experience, and skills<\/li>\n<li>Sharing challenges and successes<\/li>\n<li>Reflection on practice<\/li>\n<\/ul>\n"
            }, {
                "title": "Ngā Ohu Tōpū",
                "title_bold": "Regional Hui",
                "text": "<ul>\n<li>Networking<\/li>\n<li>Quarterly or bi-annual meetings<\/li>\n<li>Cultural protocols observed<\/li>\n<li>Discuss local issues and their impact<\/li>\n<li>Build a directory of local referral partners<\/li>\n<li>Local data sharing and resource development<\/li>\n<li>Cross-regional collaboration<\/li>\n<li>Guest speakers<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Tikanga Tika",
                "title_bold": "Topical Learning",
                "text": "<ul>\n<li>Current issues and emerging trends<\/li>\n<li>Legislative updates<\/li>\n<li>Best practice workshops<\/li>\n<li>Expert presentations<\/li>\n<li>Specialist topic deep dives<\/li>\n<li>Learning new skills, exploring new methodologies<\/li>\n<\/ul>\n"
            }, {
                "title": "Hui Tau",
                "title_bold": "National Conference",
                "text": "<ul>\n<li>National networking<\/li>\n<li>Industry updates<\/li>\n<li>Keynote speakers<\/li>\n<li>National data sharing<\/li>\n<li>Showcasing innovations<\/li>\n<li>Research presentations<\/li>\n<li>Workshops for professional development (CPD)<\/li>\n<li>Awards and recognition<\/li>\n<\/ul>\n"
            }],
            "popup_bg": "#ed4d7f",
            "accordion_bg": "#f1799f"
        }, "bottom-left": {
            "title": "Kia whaia tonu<br>te iti kahurangi",
            "desc": "Continuing Professional Development",
            "accordion": [{
                "title": "Te Kete Wānanga",
                "title_bold": "CPD Portal",
                "text": "<ul>\n<li>Planning and progress tracking tool<\/li>\n<li>Goal setting<\/li>\n<li>Training records and transcript downloads<\/li>\n<li>Resource library<\/li>\n<li>Training calendar<\/li>\n<li>Reflection<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Pikinga Maunga",
                "title_bold": "Reaching Goals",
                "text": "<ul>\n<li>Goal setting plans<\/li>\n<li>Professional development plans<\/li>\n<li>Achievement recognition<\/li>\n<li>Career planning support<\/li>\n<li>Competency advancement<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Ao Hou",
                "title_bold": "New Opportunities",
                "text": "<ul>\n<li>Recruitment options<\/li>\n<li>Leadership roles<\/li>\n<li>Teaching and facilitation roles<\/li>\n<li>Research participation<\/li>\n<li>Career advancement paths<\/li>\n<li>Cross-sector engagement<\/li>\n<\/ul>\n"
            }, {
                "title": "Tū mai te toki",
                "title_bold": "Build Skills",
                "text": "<ul>\n<li>Reach learning milestones and goals<\/li>\n<li>Reflect and grow in the role<\/li>\n<li>Cultural competency enhancement<\/li>\n<li>Professional practice updates<\/li>\n<li>Leadership development<\/li>\n<li>\n<div class=\"ql-block\" data-block-id=\"block-5368cc45-e34d-49ea-b8da-bca335bc5c8f\">Technology updates<\/div>\n<\/li>\n<li>Non-accredited courses<\/li>\n<\/ul>\n"
            }],
            "popup_bg": "#e8215f",
            "accordion_bg": "#ed4d7f"
        }, "left": {
            "title": "Ngā Ringa Raupā",
            "desc": "Volunteers",
            "accordion": [{
                "title": "Mahitahi",
                "title_bold": "Pathways to Volunteering",
                "text": "<ul>\n<li>Clear entry point<\/li>\n<li>Volunteer onboarding process<\/li>\n<li>Training programme<\/li>\n<li>Orientation programme<\/li>\n<li>Volunteer placement<\/li>\n<li>Health and safety<\/li>\n<\/ul>\n"
            }, {
                "title": "Te Paepae Tautoko",
                "title_bold": "Volunteer Support Network",
                "text": "<ul>\n<li>Community of practice<\/li>\n<li>Connection portal for volunteers<\/li>\n<li>Peer-to-peer learning support<\/li>\n<li>Development opportunities matching interests and skills<\/li>\n<li>Engagement surveys<\/li>\n<li>Career advancement opportunities<\/li>\n<li>Recognition programme<\/li>\n<\/ul>\n"
            }, {
                "title": "Tikanga Ringa Raupā",
                "title_bold": "Volunteer Position Guidelines",
                "text": "<ul>\n<li>Code of conduct<\/li>\n<li>Role clarification<\/li>\n<li>Position description<\/li>\n<li>Skilled and unskilled volunteering<\/li>\n<li>Supervision<\/li>\n<li>Ongoing training and development<\/li>\n<li>Evaluation<\/li>\n<\/ul>\n"
            }, {
                "title": "Te raupā o te ringa",
                "title_bold": "Recognition of Experience",
                "text": "<ul>\n<li>Skills assessment<\/li>\n<li>Recognition of prior learning and experience<\/li>\n<li>Assessment of prior learning and experience<\/li>\n<li>Cultural competency<\/li>\n<\/ul>\n"
            }],
            "popup_bg": "#b82f53",
            "accordion_bg": "#e8215f"
        }
    };

    function initTeTapa() {
        document.querySelectorAll('.segment-animate').forEach((element, index) => {
            window.setTimeout(() => {
                element.classList.remove('elementor-invisible');
            }, index * 200);
        });

        document.querySelectorAll('.segment button').forEach((button) => {
            button.addEventListener('click', () => {
                const segment = button.closest('.segment');
                const id = segment?.dataset.id;
                const data = accordionData?.[id];
                const accordionContainer = document.querySelector('#accordion-container');

                if (!data || !accordionContainer) {
                    return;
                }

                accordionContainer.replaceChildren();

                document.querySelectorAll('.d-popup-content').forEach((popupContent) => {
                    popupContent.style.backgroundColor = data.popup_bg;
                });

                data.accordion.forEach((section) => {
                    const item = document.createElement('div');
                    const toggle = document.createElement('button');
                    const content = document.createElement('div');

                    item.className = 'd-accordion-item';
                    toggle.className = 'd-accordion-toggle';
                    toggle.innerHTML = `${section.title}<br><b>${section.title_bold}</b>`;
                    content.className = 'd-accordion-content';
                    content.innerHTML = section.text;
                    content.style.backgroundColor = data.accordion_bg;

                    item.append(toggle, content);
                    accordionContainer.append(item);
                });

                document.querySelectorAll('.d-popup').forEach((popup) => {
                    fadeIn(popup, 300);
                    popup.setAttribute('popup-bg', id);
                });
            });
        });

        document.addEventListener('click', (event) => {
            const toggle = event.target.closest('.d-accordion-toggle');

            if (!toggle) {
                return;
            }

            const content = toggle.nextElementSibling?.matches('.d-accordion-content')
                ? toggle.nextElementSibling
                : null;

            if (!content) {
                return;
            }

            document.querySelectorAll('.d-accordion-content').forEach((accordionContent) => {
                if (accordionContent !== content) {
                    slideUp(accordionContent);
                }
            });

            document.querySelectorAll('.d-accordion-toggle').forEach((accordionToggle) => {
                if (accordionToggle !== toggle) {
                    accordionToggle.classList.remove('active');
                }
            });

            if (isVisible(content)) {
                slideUp(content);
                toggle.classList.remove('active');
                return;
            }

            slideDown(content);
            toggle.classList.add('active');
        });

        document.querySelectorAll('.d-popup-overlay').forEach((overlay) => {
            overlay.addEventListener('click', () => {
                document.querySelectorAll('.d-popup').forEach((popup) => fadeOut(popup, 300));
            });
        });

        document.querySelectorAll('.mobile-accordion .accordion-header').forEach((header) => {
            header.addEventListener('click', () => {
                const content = header.nextElementSibling?.matches('.accordion-content')
                    ? header.nextElementSibling
                    : null;
                const item = header.closest('.accordion-item');

                if (!content || !item) {
                    return;
                }

                document.querySelectorAll('.mobile-accordion .accordion-content').forEach((accordionContent) => {
                    if (accordionContent !== content) {
                        slideUp(accordionContent);
                    }
                });

                document.querySelectorAll('.mobile-accordion .accordion-header').forEach((accordionHeader) => {
                    if (accordionHeader !== header) {
                        accordionHeader.classList.remove('active');
                    }
                });

                document.querySelectorAll('.mobile-accordion .accordion-item').forEach((accordionItem) => {
                    if (accordionItem !== item) {
                        accordionItem.classList.remove('active');
                    }
                });

                if (isVisible(content)) {
                    slideUp(content);
                    header.classList.remove('active');
                    item.classList.remove('active');
                    return;
                }

                slideDown(content);
                header.classList.add('active');
                item.classList.add('active');
            });
        });
    }

    function initCircleDiagram() {
        const diagram = document.querySelector('.circle-diagram');
        const clockwiseOrder = [
            'top',
            'top-right',
            'bottom-right',
            'bottom',
            'bottom-left',
            'left',
        ];

        function animateSegmentsClockwise() {
            if (!diagram) {
                return;
            }

            const rect = diagram.getBoundingClientRect();

            if (rect.top < window.innerHeight && rect.bottom > 0) {
                clockwiseOrder.forEach((position, index) => {
                    const segment = diagram.querySelector(`.segment.${position}`);

                    if (segment) {
                        window.setTimeout(() => {
                            segment.classList.add('visible');
                        }, index * 600);
                    }
                });

                window.removeEventListener('scroll', animateSegmentsClockwise);
            }
        }

        window.addEventListener('scroll', animateSegmentsClockwise);
        animateSegmentsClockwise();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTeTapa);
    } else {
        initTeTapa();
    }

    if (document.readyState === 'complete') {
        initCircleDiagram();
    } else {
        window.addEventListener('load', initCircleDiagram);
    }


}
